import { useEffect, useState } from "react";

export type TrafficInfoFilterDef = {
  Key: string;          // "BUS", "TRAIN", ...
  Name: string;         // "Buss", "Tåg"
  CssClass: string;     // "BUS"
  IconCssClass: string; // icon
};

const apiBaseUrl = process.env.REACT_APP_TPS_API_BASE_URL?.replace(/\/$/, "") ?? "";

const FILTERS_URL =
  `${apiBaseUrl}/api/v1/TrafficTypes/TrafficInfoFilters`;

export function useTrafficInfoFilters() {
  const [filters, setFilters] = useState<TrafficInfoFilterDef[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(FILTERS_URL)
      .then((res) => res.json())
      .then(setFilters)
      .finally(() => setLoading(false));
  }, []);

  return { filters, loading };
}
